import React from 'react';
import ExternalAppTemplate from '../Pipedream/ExternalAppTemplate';
import { EXTERNAL_APP_CAPABILITIES } from '../Pipedream/externalAppCapability';

const PerformActionExternalTemplate = (props) => (
  <ExternalAppTemplate {...props} capabilityConfig={EXTERNAL_APP_CAPABILITIES.action} />
);

export default PerformActionExternalTemplate;
